import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getFunctions, Functions } from 'firebase/functions';

// NOTE: Firebase "apiKey" is not a secret. We still prefer env vars, but we also
// provide a fallback to avoid runtime failures if env values are not inlined into
// the client bundle (which would make apiKey undefined and trigger auth/api-key-not-valid).
const readTrimmedEnv = (key: string) => {
  const raw = process.env[key];
  if (typeof raw !== 'string') return undefined;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

const fallbackConfig = {
  apiKey: 'AIzaSyCYs4alU_LHxRToPVVrBadeWv__tuGsHeo',
  authDomain: 'vakpegapp-5bcf0.firebaseapp.com',
  projectId: 'vakpegapp-5bcf0',
  storageBucket: 'vakpegapp-5bcf0.appspot.com',
  messagingSenderId: '377779341678',
  appId: '1:377779341678:web:5587454e1def7774f6d97f',
  measurementId: 'G-0J0J4YEXRB',
};

const envConfig = {
  apiKey: readTrimmedEnv('NEXT_PUBLIC_FIREBASE_API_KEY'),
  authDomain: readTrimmedEnv('NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN'),
  projectId: readTrimmedEnv('NEXT_PUBLIC_FIREBASE_PROJECT_ID'),
  storageBucket: readTrimmedEnv('NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: readTrimmedEnv('NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID'),
  appId: readTrimmedEnv('NEXT_PUBLIC_FIREBASE_APP_ID'),
  measurementId: readTrimmedEnv('NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID'),
};

const hasCompleteEnvConfig =
  !!envConfig.apiKey &&
  !!envConfig.authDomain &&
  !!envConfig.projectId &&
  !!envConfig.storageBucket &&
  !!envConfig.messagingSenderId &&
  !!envConfig.appId;

const firebaseConfig = hasCompleteEnvConfig
  ? {
      apiKey: envConfig.apiKey,
      authDomain: envConfig.authDomain,
      projectId: envConfig.projectId,
      storageBucket: envConfig.storageBucket,
      messagingSenderId: envConfig.messagingSenderId,
      appId: envConfig.appId,
      measurementId: envConfig.measurementId ?? fallbackConfig.measurementId,
    }
  : fallbackConfig;

export const firebaseWebConfig = firebaseConfig;

// Initialize Firebase
let app: FirebaseApp;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Initialize services
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);
export const functions: Functions = getFunctions(app);

export default app;
